import { useEffect } from "react";
import { shakaSetVideoPlayerControlState } from "../playerHelpers/shakaPlayerControls";

export const useUnloadPlayer = (playerMgr, currentContentId) => {
  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      playerMgr.current?.unload();
    };
  }, [currentContentId, playerMgr]);
};

export const usePlayerUnmount = (playerMgr) => {
  useEffect(() => {
    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      playerMgr.current?.destroy();
    };
  }, [playerMgr]);
};

export const useInitPlayerControls = (playerMgr, control) => {
  // Handle External Player Controls for Stop, Play and Pause of the video player
  useEffect(() => {
    shakaSetVideoPlayerControlState(playerMgr.current, control);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [control]);
};
